const octadeskScript = `
  (function (o, c, t, a, d, e, s, k) {
    o.octadesk = o.octadesk || {};
    o.octadesk.chatOptions = {
      subDomain: a,
      showButton: d,
      openOnMessage: e,
      hide: s
    };
    var bd = c.getElementsByTagName("body")[0];
    var sc = c.createElement("script");
    sc.async = 1;
    sc.src = t;
    bd.appendChild(sc);
  })(window, document, 'https://cdn.octadesk.com/embed.js', 'o150592-14d', 'true', 'true', 'false');
`

export function initializeOctadeskChat(): void {
  const script = document.createElement('script')
  script.innerHTML = octadeskScript
  document.body.appendChild(script)
}